export const path = "/base-project";
export const component = () => import("./index.jsx");
export const enabled = false;
export const sidebar = {
  title: "BASE PROJECT",
  section: "IONVO",
  group: null,
  order: 2,
  roles: ["Authenticated"],
};
